/**
 * File: block-editor.js
 *
 * Allowed blocks in block editor.
 */
const { unregisterBlockType } = window.wp.blocks;

document.addEventListener( 'DOMContentLoaded', unregisterBlocks );

function unregisterBlocks() {
	const disabledBlocks = [
		'core/calendar',
		'core/categories',
		'core/classic',
		'core/gallery',
		'core/html',
		'core/latest-comments',
		'core/latest-posts',
		'core/loginout',
		'core/more',
		'core/media-text',
		'core/nextpage',
		'core/page-list',
		'core/post-content',
		'core/post-date',
		'core/post-excerpt',
		'core/post-title',
		'core/post-terms',
		'core/query',
		'core/query-title',
		'core/rss',
		'core/search',
		'core/separator',
		'core/site-logo',
		'core/site-tagline',
		'core/site-title',
		'core/social-links',
		'core/table',
		'core/tag-cloud',
		'core/verse',
		'yoast/how-to-block',
		'yoast/faq-block',
	];

	disabledBlocks.forEach( function ( block ) {
		unregisterBlockType( block );
	} );
}
